import React, {useEffect} from 'react';
import {connect} from "react-redux";
import Grid from "@mui/material/Grid2";
import {dashboardActions} from "../../../modules/dashboard/dashboard.actions";
import DashboardHeaderControls from "./ui/DashboardHeaderControls";
import DashboardMap from "./map/DashboardMap";
import Loader from "../layout/loading/loader";
import {helper} from "../../../utils/helper";
import Constants from "../../../utils/constants.js";
import {dashboardHelper} from "./utils/dashboardHelper.js";
import DashboardMapSidePanel from "./ui/DashboardMapSidePanel.js";
import DashboardMapBottomSheet from "./map/DashboardMapBottomSheet.js";

const DashboardMapView = ({data, loading, error, dispatch, onModeChange}) => {
    const mapRef = React.useRef();
    const [selectedDate, setSelectedDate] = React.useState(dashboardHelper.formatDateRelative(0));
    const [selectedTournee, setSelectedTournee] = React.useState(null);

    const currentUser = helper.getCurrentUser();

    const loadData = (forceReload = false) => {
        if (!loading && (!error || forceReload)) {
            let values = {exploitantId: currentUser?.id, date: selectedDate};
            dispatch(dashboardActions.fetchDashboardDataV2(values));
        }
    };

    useEffect(() => {
        if (!data) {
            loadData();
        }
        const intervalId = setInterval(loadData, 900000); // 900000 ms = 15 minutes

        // Nettoyage de l'effet
        return () => clearInterval(intervalId);
    }, [currentUser, dispatch]);

    const handleOnTourneeClick = (tournee) => {
        setSelectedTournee(tournee);

        const coordinates = dashboardHelper.getCoordinatesFromConteneurs(tournee.conteneurs);

        if (mapRef.current && coordinates.length > 0) {
            const leafletMap = mapRef.current;
            const bounds = L.latLngBounds(coordinates);
            leafletMap.flyToBounds(bounds, { padding: [50, 50], duration: 0.75 });
        }
    }

    return (
        <Grid container>
            <DashboardHeaderControls
                selectedDate={selectedDate}
                onDateChange={(date) => {
                    setSelectedDate(date)
                    dispatch(dashboardActions.fetchDashboardDataV2({exploitantId: currentUser?.id, date}))
                }}
                onReload={() => loadData(true)}
                lastUpdated={data?.lastUpdated}
                viewMode={Constants.DASHBOARD_VIEW_MODE_MAP}
                onViewModeChange={onModeChange}
            />

            {loading && <Loader/>}

            {!loading && data && (
                <Grid container sx={{width:'100%', marginTop: '1rem'}}>
                    <Grid size={{xs:7}} id={"dashboard-map-container"} sx={{ position: 'relative' }}>
                        <DashboardMap
                            mode={"exploitant"}
                            clientsData={data.clients}
                            laveusesData={data.laveuses}
                            selectedDate={selectedDate}
                            onTourneeClick={setSelectedTournee}
                            mapRef={mapRef}
                        />
                        <DashboardMapBottomSheet
                            tournee={selectedTournee}
                            open={!!selectedTournee}
                            onClose={() => setSelectedTournee(null)}
                        />
                    </Grid>

                    <Grid size={{xs:5}}>
                        <DashboardMapSidePanel
                            mode={"exploitant"}
                            clientsData={data.clients}
                            selectedTournee={selectedTournee}
                            onTourneeClick={handleOnTourneeClick}
                        />
                    </Grid>
                </Grid>

            )}
        </Grid>
    );
};

const mapStateToProps = (state) => ({
    data: state.dashboard.datav2,
    loading: state.dashboard.loading,
    error: state.dashboard.error
});

export default connect(mapStateToProps)(DashboardMapView);
